export default "__VITE_ASSET__Bn2vjlUx__"